<template>
    <div class="stripe-coupon-component">
        <b-alert variant="success" :show="isSuccess">Your discount has been applied successfully.</b-alert>
        <b-alert variant="danger" :show="hasError">{{ error }}</b-alert>

        <div class="input-group">
            <input type="text" class="form-control" placeholder="Coupon/discount code" v-model="discountCode">
            <b-button variant="primary" @click="handleDiscount">Apply</b-button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            selectedPlan: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                isSuccess: false,
                isBusy: false,
                error: false,
                hasError: false,
                discountCode: '',
            }
        },

        mounted() {
        },

        methods: {
             handleDiscount() {
                this.isBusy = true;
                this.btnText = 'Please wait...';
                this.hasError = false;

                axios.post('/api/discounts/stripe/' + this.selectedPlan.id + '/check', {
                    'code': this.discountCode
                })
                    .then((response) => {
                        if(response.data.success) {
                            Bus.$emit('discountUpdated', response.data);
                            this.isSuccess = true;
                        }

                        if(response.data.error) {
                            this.hasError = true;
                            this.error = response.data.error;
                            this.isBusy = false;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.hasError = true;
                        this.error = 'An unexpected error occured.';
                        this.isBusy = false;
                    });
            },
        }
    }
</script>
